<div class="main-content checklist-completion-page">
  <header class="completion-page-heading">
    <div class="completion-heading-copy">
      <h1>{{ CompleteCheckList.Title || checklistTitle }}</h1>
      <p class="completion-context">
        <span *ngIf="projectTitle">{{ projectTitle }}</span>
        <span *ngIf="CompleteCheckList.ResponsibleId"
          >{{ "RESPONSIBLE" | translate }}:
          {{ completionResponsibleLabel }}</span
        >
        <span *ngIf="CompleteCheckList.Location"
          >{{ "LOCATION" | translate }}: {{ CompleteCheckList.Location }}</span
        >
        <span *ngIf="CompleteCheckList.InitDate"
          >{{ "CHECKLIST_REDESIGN.STARTED" | translate }}
          {{ CompleteCheckList.InitDate | date: "short" }}</span
        >
      </p>
    </div>
  </header>
  <div class="card completion-content">
    <div class="card-body completion-content-body">
      <tabset #staticTabs>
        <tab>
          <ng-template tabHeading>
            <span
              class="completion-step-circle"
              [class.done]="
                staticTabs.tabs[1]?.active || staticTabs.tabs[2]?.active
              "
            >
              <svg
                *ngIf="
                  staticTabs.tabs[1]?.active || staticTabs.tabs[2]?.active;
                  else stepNumber1
                "
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                stroke-width="2.4"
                stroke-linecap="round"
                stroke-linejoin="round"
                aria-hidden="true"
              >
                <path d="M5 12l5 5L20 7" />
              </svg>
              <ng-template #stepNumber1>1</ng-template>
            </span>
            <span>{{ "CHECKLIST_REDESIGN.STEP_DETAILS" | translate }}</span>
          </ng-template>

          <!--Panel Loader-->
          <kuba-busy [busy]="showLoader" message="PROCESSING"></kuba-busy>
          <!--Panel Loader-->

          <div class="tab-content">
            <div class="form-group">
              <label for="title">
                <span translate>TITLE</span>
                <span class="required">*</span>
              </label>
              <div>
                <input
                  type="text"
                  [(ngModel)]="CompleteCheckList.Title"
                  id="title"
                  name="title"
                  #title="ngModel"
                  required
                  class="form-control"
                />
              </div>
              <div
                *ngIf="title.invalid && (title.dirty || title.touched)"
                class="alert alert-danger"
              >
                <div *ngIf="title.errors['required']" translate>REQUIRED</div>
              </div>
            </div>
            <div class="form-group">
              <label>
                <span translate>DATE</span>
              </label>
              <div>
                {{ CompleteCheckList.InitDate | date: "dd-MM-yyyy" }}
              </div>
            </div>
            <div class="form-group">
              <label>
                <span translate>RESPONSIBLE</span>
                <span class="required">*</span>
              </label>
              <div *ngIf="responsibleperson">
                <p-select
                  id="responsible"
                  #responsible="ngModel"
                  [options]="responsibleperson"
                  required
                  [(ngModel)]="CompleteCheckList.ResponsibleId"
                  [placeholder]="'SELECT_DROPDOWN.SELECT' | translate"
                  [style]="{ width: '130px' }"
                >
                </p-select>
              </div>
            </div>
            <div class="form-group">
              <label for="location">
                <span translate>LOCATION</span>
              </label>
              <div>
                <input
                  type="text"
                  [(ngModel)]="CompleteCheckList.Location"
                  id="location"
                  name="location"
                  #location="ngModel"
                  required
                  class="form-control"
                />
              </div>
            </div>
            <div class="form-group">
              <label>
                <span translate>PARTICIPANTS</span>
              </label>
              <div>
                <textarea
                  [(ngModel)]="CompleteCheckList.Participants"
                  id="participants"
                  class="form-control"
                ></textarea>
              </div>
            </div>
            <div class="action-btns-wrapper checklist-action-bar">
              <button (click)="Back()" class="btn btn-outline-secondary">
                <span translate>BACK</span>
              </button>
              <button
                [disabled]="!title.valid || !CompleteCheckList.ResponsibleId"
                (click)="SaveFirstStepCompleteCheckList()"
                class="btn btn-primary"
              >
                <span translate>SAVE_AND_NEXT </span>
              </button>
            </div>
          </div>
        </tab>
        <tab>
          <ng-template tabHeading>
            <span
              class="completion-step-circle"
              [class.done]="staticTabs.tabs[2]?.active"
            >
              <svg
                *ngIf="staticTabs.tabs[2]?.active; else stepNumber2"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                stroke-width="2.4"
                stroke-linecap="round"
                stroke-linejoin="round"
                aria-hidden="true"
              >
                <path d="M5 12l5 5L20 7" />
              </svg>
              <ng-template #stepNumber2>2</ng-template>
            </span>
            <span>{{
              "CHECKLIST_REDESIGN.STEP_CHECKPOINTS_LABEL" | translate
            }}</span>
          </ng-template>

          <!--Panel Loader-->
          <kuba-busy [busy]="showLoader" message="PROCESSING"></kuba-busy>
          <!--Panel Loader-->
          <div class="tab-content">
            <div *ngIf="CompleteChecklistEdit.Section">
              <kuba-checklist-checkpoints
                [showRemaining]="false"
                [showSectionNavigation]="false"
                [sections]="CompleteChecklistEdit.Section"
                [scoreEnabled]="isScoreIndex"
                [uploader]="upConfig"
                [references]="
                  featureId == elFeatureKey ? checkListReference || [] : []
                "
                (statusChanged)="
                  setStatus($event.status, $event.item.Status, $event.item)
                "
                (changed)="checkpointChanged($event)"
                (uploadingChanged)="uploading = $event"
              >
              </kuba-checklist-checkpoints>
            </div>
            <div
              class="action-btns-wrapper checklist-action-bar completion-footer"
            >
              <button
                [disabled]="uploading || draftSaving"
                (click)="Saveforlater()"
                class="btn btn-outline-secondary"
              >
                <span translate>SAVE_FOR_LATER</span>
              </button>
              <button
                class="btn completion-print"
                [disabled]="uploading || draftSaving"
                (click)="Saveforlater(true)"
                pTooltip="{{ 'AUTOSAVE_ON_PRINT' | translate }}"
              >
                <i class="pi pi-print" aria-hidden="true"></i
                ><span translate>PRINT_AS_PDF</span>
              </button>
              <span
                class="draft-status"
                [class.saved]="draftStatus === 'CHECKLIST_REDESIGN.DRAFT_SAVED'"
                [class.failed]="
                  draftStatus === 'CHECKLIST_REDESIGN.DRAFT_ERROR'
                "
                role="status"
                ><i
                  *ngIf="draftStatus"
                  class="pi"
                  [class.pi-check]="
                    draftStatus === 'CHECKLIST_REDESIGN.DRAFT_SAVED'
                  "
                  [class.pi-exclamation-circle]="
                    draftStatus === 'CHECKLIST_REDESIGN.DRAFT_ERROR'
                  "
                  [class.pi-spin]="draftSaving"
                  [class.pi-spinner]="draftSaving"
                  aria-hidden="true"
                ></i
                >{{ draftStatus | translate }}</span
              >
              <span
                class="completion-remaining"
                *ngIf="completionAnswered < completionTotal"
                >{{
                  "CHECKLIST_REDESIGN.REMAINING"
                    | translate
                      : {
                          count: completionTotal - completionAnswered
                        }
                }}
                <button
                  type="button"
                  (click)="checkpointPanel.firstUnanswered()"
                >
                  {{ "CHECKLIST_REDESIGN.FIRST_UNANSWERED" | translate }}
                </button></span
              >
              <button
                *ngIf="completionIsLong"
                type="button"
                class="btn btn-outline-secondary"
                [disabled]="completionActiveSection === 0"
                (click)="
                  checkpointPanel.selectSection(
                    checkpointPanel.activeSection - 1
                  )
                "
              >
                <i class="pi pi-chevron-left" aria-hidden="true"></i
                >{{ "CHECKLIST_REDESIGN.PREVIOUS_SECTION" | translate }}
              </button>
              <button
                *ngIf="
                  completionIsLong &&
                  completionActiveSection < completionSectionCount - 1
                "
                type="button"
                class="btn btn-primary"
                (click)="
                  checkpointPanel.selectSection(
                    checkpointPanel.activeSection + 1
                  )
                "
              >
                {{ "CHECKLIST_REDESIGN.NEXT_SECTION" | translate
                }}<i class="pi pi-chevron-right" aria-hidden="true"></i>
              </button>
              <button
                *ngIf="
                  !completionIsLong ||
                  completionActiveSection === completionSectionCount - 1
                "
                (click)="SaveSecondStepCompleteCheckList()"
                class="btn btn-primary completion-continue"
                [disabled]="checkValid() || uploading || draftSaving"
              >
                {{ "CHECKLIST_REDESIGN.CONTINUE_FINISH" | translate
                }}<i class="pi pi-arrow-right" aria-hidden="true"></i>
              </button>
            </div>
          </div>
        </tab>
        <tab>
          <ng-template tabHeading
            ><span class="completion-step-circle">3</span
            ><span>{{
              "CHECKLIST_REDESIGN.STEP_FINISH" | translate
            }}</span></ng-template
          >

          <!--Panel Loader-->
          <kuba-busy [busy]="showLoader" message="PROCESSING"></kuba-busy>
          <!--Panel Loader-->
          <div class="tab-content">
            <div class="row">
              <div class="col-sm-6">
                <label>
                  <span translate>FOOD_SAFETY_APPROVAL</span>
                </label>
                <div class="checkbox">
                  <label>
                    <input type="checkbox" [(ngModel)]="aproval" />
                    <span translate>FOOD_SAFETY_CHECKLIST_COMPLETED</span>
                  </label>
                </div>
              </div>
              <div
                *ngIf="type != 'feature' && type != 'task-manager'"
                class="col-sm-6"
              >
                <div class="form-group">
                  <label>
                    <span translate>SELECT_FOLDER_ARCHIVE_CHECKLIST</span>
                    <span>{{ selectFolderName }}</span>
                  </label>
                </div>
                <div class="mtop-20">
                  <app-ecpl-document-tree
                    *ngIf="treeNode"
                    treeId="ArchiveDocumentsTree"
                    [(ecplTreeData)]="treeNode"
                    (ecplNodeEvent)="catchEvent($event)"
                    [treeType]="treeType"
                  >
                  </app-ecpl-document-tree>
                </div>
              </div>
              <div
                *ngIf="type === 'feature' || type === 'task-manager'"
                class="col-sm-6"
              >
                <div class="form-group">
                  <label>
                    <span translate>FOOD_SAFETY_SELECT_FOLDER</span>
                    - <span>{{ selectFeatureFolderName }}</span>
                  </label>
                </div>
                <div class="mtop-20">
                  <app-ecpl-document-tree
                    *ngIf="featureTreeNode"
                    treeId="ArchiveDocumentsTree"
                    [(ecplTreeData)]="featureTreeNode"
                    (ecplNodeEvent)="onFeatureCatchEvent($event)"
                    [treeType]="treeType"
                  >
                  </app-ecpl-document-tree>
                </div>
              </div>
            </div>
            <div class="action-btns-wrapper checklist-action-bar">
              <button
                (click)="SaveAndCompleteChecklist()"
                [disabled]="isCheckBoxTicked()"
                class="btn btn-primary"
              >
                <span translate>SAVE_AND_COMPLETE</span>
              </button>
            </div>
          </div>
        </tab>
      </tabset>
    </div>
  </div>
</div>
<p-confirmDialog
  width="425"
  acceptLabel="{{ 'SWITCH_YES' | translate }}"
  rejectLabel="{{ 'SWITCH_NO' | translate }}"
>
</p-confirmDialog>
